import { Paper, styled } from "@mui/material";
import { timePickerName } from "../classes.js";
const excludedProps = ["as", "ownerState", "theme", "sx", "inputWidth"];
const MenuPaper = styled(Paper, {
  name: timePickerName,
  slot: "menuPaper",
  overridesResolver: (_props, styles) => styles.menuPaper,
  shouldForwardProp: (prop) => !excludedProps.includes(prop)
})(({ inputWidth }) => ({
  width: inputWidth
}));
export {
  MenuPaper
};
//# sourceMappingURL=MenuPaper.js.map
